export const checkBeforeAddToCart = ({
  product,
  variant,
  quantity,
}: {
  product: any;
  variant: any;
  quantity: number;
}) => {
  const hasProduct = product && product.id;
  const hasVariant = variant && variant.id && variant.price !== undefined;
  const hasQuantity = quantity > 0;

  if (!hasProduct) {
    console.warn("Invalid product data");
    return false;
  }

  if (!hasVariant) {
    console.warn("Invalid variant data");
    return false;
  }

  if (!hasQuantity) {
    console.warn("Quantity must be greater than zero");
    return false;
  }

  return true;
};
